<template>
  <table class="table grid-12" cellspacing="0" cellpadding="0">
    <tr>
      <th @click="changeFilter('id', 0)" v-html="filterIcons('Job', 0)"></th>
      <th @click="changeFilter('status_cliente', 1)" v-html="filterIcons('Status', 1)"></th>
      <th @click="changeFilter('dh_agendamento_cliente', 2)" v-html="filterIcons('Agendado para', 2)"></th>
      <th @click="changeFilter('candidatos', 3)" v-html="filterIcons('Candidatos', 3)"></th>
      <th @click="changeFilter('cidade', 4)" v-html="filterIcons('Cidade', 4)"></th>
      <th @click="changeFilter('nome_doutor', 5)" v-html="filterIcons('Supporter', 5)" class="tableHide"></th>
      <th class="tableHide">Celular</th>
      <th class="tableHide" width="160">Ações</th>
    </tr>

    <tr v-for="(job, i) in jobs" :key="'jobrow' + i">
      <td>{{ job.id }}</td>
      <td>{{ job.status_cliente.replace("Doutor", "Supporter") }}</td>
      <td>
        {{ new Date(job.dh_agendamento_cliente).toLocaleString().substr(0, 16) }}
      </td>
      <td>{{ job.candidatos }}</td>
      <td>{{ job.cidade + "/" + job.estado }}</td>
      <td class="tableHide">{{ job.nome_doutor }}</td>
      <td class="tableHide">{{ job.celular_doutor | phone }}</td>
      <td class="tableHide">
        <Button class="detail" layout="green-s">
          <a :href="'/cliente/job/' + job.id">MAIS DETALHES</a>
        </Button>
      </td>
    </tr>
  </table>
</template>

<script>
import Button from "@/components/Button.vue";
import TableFilter from "@/components/mixins/TableFilter";
export default {
  components: { Button },
  mixins: [TableFilter],
  props: {
    jobs: {
      type: Array,
      required: true,
    },
    pager: {
      type: Number,
    },
  },
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;

.table {
  color: $gray-6;
  padding-right: 55px;
  font-size: 14px;
  border-radius: 23px;

  tr {
    &:nth-child(even) {
      background: $white-9;
    }

    &:nth-child(odd) {
      background: $white;
    }
  }

  td,
  th {
    height: 48px;
    padding: 5px;

    &:first-child {
      padding-left: 15px;
    }

    &:last-child {
      padding-right: 15px;
    }
  }

  th {
    background: $white;
    text-align: left;

    &:hover {
      color: $green-1;
      cursor: pointer;
    }
  }
}

.opened {
  .tableHide {
    display: none;
  }
}
</style>
